var exports = {
  "k": "StackUserAvatar.module__container___NENZMF",
};

module.exports = exports;
